// extracted by mini-css-extract-plugin
module.exports = {"container":"dividends-sector_container__22zLl","content":"dividends-sector_content__HxueQ","text":"dividends-sector_text__7JiGu"};